const language = {
  lang: 'en-US',
  gameID: 269,
  websiteId: 269,
  'en-US': {
    newsID: '',
    guidesID: '',
    eventsID: '',
    noticesID: '',
    language: '英语',
    sLang: 'en-US',
  },
  change(lang) {
    this.lang = lang;
  },
  get(key) {
    let lang = this.lang;
    return this[lang][key];
  },
  getLang() {
    return this['lang'];
  },
};
export default language;
